import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionHelper } from './../../../../helper';
import { IsActive } from './../../../../model';
import { DatePipe } from '@angular/common';

import { PreventiveMaintenanceSummaryService } from './preventive-maintenance-summary.service';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-preventive-maintenance-summary',
  templateUrl: './preventive-maintenance-summary.component.html',
  styleUrls: [
    '../../../../../scss/vendors/bs-datepicker/bs-datepicker.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class PreventiveMaintenanceSummaryComponent implements OnInit, AfterViewInit {

  @ViewChild('dangerModal') dangerModal: any;

  @ViewChild('arranging') private arrangingCheckbox ;
  @ViewChild('confirmed') private confirmedCheckbox ;
  @ViewChild('completed') private completedCheckbox ;
  @ViewChild('cancelled') private cancelledCheckbox ;
  @ViewChild('dateRange') private dateRangeCheckbox ;

  arranging: any ;
  confirmed: any ;
  completed: any ;
  cancelled: any ;
  dateRange: any ;

  isArranging = true;
  isConfirmed = true;
  isCompleted = false;
  isCancelled = false;
  isDateRange = false;

  applied: Boolean = true;

  PMs: any[];
  dataTable: any;

  today: Date = new Date();
  startOFmonth: Date = new Date();
  lastMonth: Date = new Date();

  todayFM: String;
  startOFmonthFM: String;
  lastMonthFM: String;

  startDate: String;
  endDate: String;

  bsRangeValue: any;

  customerId;
  customerName: any = null;

  constructor(
    private exception: ExceptionHelper,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private pmSummaryService: PreventiveMaintenanceSummaryService,
    private chRef: ChangeDetectorRef) {
    translateService.setDefaultLang('en-us');
    this.route.params.subscribe(params => { this.customerId = params['customerId']; });
  }

  ngAfterViewInit() {

    this.arranging = this.arrangingCheckbox.nativeElement;
    this.confirmed = this.confirmedCheckbox.nativeElement;
    this.completed = this.completedCheckbox.nativeElement;
    this.cancelled = this.cancelledCheckbox.nativeElement;
    this.dateRange = this.dateRangeCheckbox.nativeElement;

    this.getSummary(IsActive.active, IsActive.active, IsActive.inactive, IsActive.inactive, '', '');
  }

  ngOnInit() {

    this.startOFmonth.setDate(1);
    this.lastMonth.setMonth(this.lastMonth.getMonth() - 1);

    this.bsRangeValue = [];

    this.todayFM = this.datePipe.transform(this.today , 'yyyy-MM-dd');
    this.startOFmonthFM = this.datePipe.transform(this.startOFmonth , 'yyyy-MM-dd');
    this.lastMonthFM = this.datePipe.transform(this.lastMonth , 'yyyy-MM-dd');

    this.startDate = this.lastMonthFM;
    this.endDate = this.todayFM;
  }


  apply() {

    this.isArranging = this.arranging.checked;
    this.isConfirmed = this.confirmed.checked;
    this.isCompleted = this.completed.checked;
    this.isCancelled = this.cancelled.checked;
    this.isDateRange = this.dateRange.checked;

    const para_arranging = (this.arranging.checked === true ? IsActive.active : IsActive.inactive);
    const para_confirmed = (this.confirmed.checked === true ? IsActive.active : IsActive.inactive);
    const para_completed = (this.completed.checked === true ? IsActive.active : IsActive.inactive);
    const para_cancelled = (this.cancelled.checked === true ? IsActive.active : IsActive.inactive);

    if (this.isDateRange && this.bsRangeValue.length === 2) {
      this.getSummary(para_arranging, para_confirmed, para_completed, para_cancelled,
        this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd'), this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd') );
    } else {
      this.getSummary(para_arranging, para_confirmed, para_completed, para_cancelled,
        '', '');
    }

  }
  filterChange() {


    if (this.isArranging === this.arranging.checked && this.isConfirmed === this.confirmed.checked &&
        this.isCompleted === this.completed.checked && this.isCancelled === this.cancelled.checked &&
        this.startDate === this.datePipe.transform(this.bsRangeValue[0], 'yyyy-MM-dd') &&  this.endDate === this.datePipe.transform(this.bsRangeValue[1], 'yyyy-MM-dd') ) {
      // unchanged
      this.applied = true;
    }
    else if (this.arranging.checked || this.confirmed.checked || this.completed.checked || this.cancelled.checked) {
      this.applied = false;
    }
    else {
      this.applied = true;
    }
    this.applied = this.dateRange === this.dateRange.checked;


  }


  getSummary(arranging, confirmed, completed, cancelled, startDate, endDate) {

    const all = (this.customerId == null ? true : false);

    this.pmSummaryService.getSummary(arranging, confirmed, completed, cancelled, startDate, endDate, all, this.customerId).subscribe( (data: any) => {
      this.applied = true;

      if ($.fn.dataTable.isDataTable('#PMsDataTables')) { $('#PMsDataTables').DataTable().destroy(); }

          this.PMs = data.pmdetailListModel;
          // this.customerName = this.PMs[0].customer;
          this.chRef.detectChanges();

          const table: any = $('#PMsDataTables');
          this.dataTable = table.DataTable({
            // 'order': [5, 'asc']
            'order': [3, 'desc']
          });
        },
        error => {
          $('.card').hide();
          this.exception.showError(error, 'showDanModalBtn');
        });

  }
  public onDateRangeChange(): void {
    this.applied = !(this.dateRange.checked === true);
  }
  errorClose() {
    if (this.customerId != null) {
      this.router.navigate(['/home/customers/detail/' + this.customerId]);
    }
    else {
      this.dangerModal.hide();
    }
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-summary/preventive-maintenance-summary.component.ts